// import messanger from '../../assets/logo/download.jfif';
import './EasyContact.css';

const EasyContact = () => {
    return (
        <div className='EsyContact'>
       <a
  href="https://wa.me/+96551494820"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-gray-300 transition"
>


     {/* <small className='messngers'> <RiMessengerLine/></small> */}
     <img src="https://cdn3.iconfinder.com/data/icons/social-network-30/512/social-01-512.png" alt="" />
   </a>
            
        </div>
    );
};

export default EasyContact;